import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

const Row = styled.div`
  display: grid;
  grid-template-columns: 20rem 1fr 12rem 12rem;
  align-items: flex-start;
  column-gap: 1.6rem;

  padding: 0.4rem 0;

  border-top: 0.1rem solid ${pickColor('borderLight')};

  &:first-child {
    border-top: none;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  padding-top: 0.2rem;
`;

const SwatchArea = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  border-radius: 0.4rem;
  width: 100%;

  &:hover {
    background: ${pickColor('gray')};
  }

  &[aria-disabled='true'] {
    cursor: wait;
    opacity: 0.6;
  }
`;

const RemoveButton = styled.button`
  width: 2rem;
  height: 2rem;

  background: ${pickColor('orange')};
  color: ${pickColor('white')};

  border: 0;
  padding: 0;

  ${getFontScale('s')};
  font-weight: bold;
  line-height: 1;

  cursor: pointer;
  flex-shrink: 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const RemoveButtonPlaceholder = styled.div`
  width: 2rem;
  height: 2rem;
`;

const ColourCodeName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
`;

const ColourCode = styled.span`
  ${getFontScale('xs')};
  font-weight: bold;
  color: ${pickColor('black')};
`;

const ColourCodeLink = styled.button`
  ${getFontScale('xs')};
  font-weight: bold;
  color: ${pickColor('black')};

  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 0.2rem;

  &:hover {
    color: ${pickColor('orange')};
  }

  &:disabled {
    cursor: wait;
    opacity: 0.6;
  }
`;

const ColourName = styled.span`
  ${getFontScale('xs')};
  color: ${pickColor('grayDark')};
`;

const SizesGrid = styled.div<{ $cols: number }>`
  display: grid;
  grid-template-columns: ${({ $cols }) => `repeat(${$cols}, minmax(2.4rem, 5rem))`};
  column-gap: 0.4rem;

  align-items: start;
`;

const SizeColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
`;

const SizeLabel = styled.span`
  ${getFontScale('xs')};
  font-weight: bold;
  color: ${pickColor('black')};
`;

const SizeQuantityValue = styled.span`
  ${getFontScale('xs')};
  color: ${pickColor('black')};
`;

const TotalsCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
  min-width: 0;

  padding-top: 0.2rem;
`;

const TotalsLabel = styled.span`
  ${getFontScale('xs')};
  color: ${pickColor('grayDark')};
  text-transform: capitalize;
`;

/* A large total wraps inside its fixed-width column, kept right-aligned */
const TotalsValue = styled.span`
  max-width: 100%;

  ${getFontScale('xs')};
  font-weight: bold;
  color: ${pickColor('black')};
  text-align: right;
  overflow-wrap: anywhere;
`;

export {
  ColourCode,
  ColourCodeLink,
  ColourCodeName,
  ColourName,
  Wrapper,
  RemoveButton,
  RemoveButtonPlaceholder,
  Row,
  SizeColumn,
  SizeLabel,
  SizeQuantityValue,
  SizesGrid,
  SwatchArea,
  TotalsCell,
  TotalsLabel,
  TotalsValue,
};
